import { GetRoundIdFromPropsType } from '../../../selectors/_propsGetters_';
import { StateType } from '../../../states';
import { GRChipStatuses } from '../types/chip';
import { GRRounds } from '../types/round';
import { GRRoundUserStatuses } from '../types/user';

import { selectGRRoundsState } from './rounds/roundsPrimary.selector';
import { selectGRUserProgress, selectGRUserRoundId } from './user/userPrimary.selector';

export const selectGRUserCurrentRound = (state: StateType) => {
  const roundId = selectGRUserRoundId(state) || GRRounds.SHOE;
  const progress = selectGRUserProgress(state);

  return progress?.[roundId] ?? undefined;
};

export const selectGRUserCurrentRoundStatus = (state: StateType) => selectGRUserCurrentRound(state)?.status;

export const selectGRUserRoundByRoundId = (state: StateType, props: GetRoundIdFromPropsType) => {
  const roundId = props.roundId;
  const progress = selectGRUserProgress(state);

  return progress?.[roundId] ?? undefined;
};

export const selectGRBetsFromRound = (state: StateType, props: GetRoundIdFromPropsType) => {
  const round = selectGRUserRoundByRoundId(state, props);

  return round?.bets ?? [];
};

export const selectGRPointsFromRound = (state: StateType, props: GetRoundIdFromPropsType) => {
  const round = selectGRUserRoundByRoundId(state, props);

  return round?.points ?? 0;
};

export const selectGRRoundWonAmountFromRound = (state: StateType, props: GetRoundIdFromPropsType) => {
  const round = selectGRUserRoundByRoundId(state, props);

  return round?.wonAmount ?? 0;
};

export const selectGRPointsBySumFromRound = (state: StateType, props: GetRoundIdFromPropsType) => {
  const bets = selectGRBetsFromRound(state, props);

  return bets.reduce(
    (acc, curr) => acc + (curr.status === GRChipStatuses.WON && curr.counted ? curr.points ?? 0 : 0),
    0,
  );
};

export const selectIsGRRoundLocked = (state: StateType, props: GetRoundIdFromPropsType) => {
  const round = selectGRUserRoundByRoundId(state, props);

  return round?.status === GRRoundUserStatuses.LOCKED;
};

export const selectIsGRRoundWon = (state: StateType, props: GetRoundIdFromPropsType) => {
  const round = selectGRUserRoundByRoundId(state, props);

  return round?.status === GRRoundUserStatuses.WON;
};

export const selectGRSpecificRuleFromRound = (state: StateType, props: GetRoundIdFromPropsType) => {
  const rounds = selectGRRoundsState(state);
  const roundId = props.roundId;

  return rounds[roundId];
};

export const selectMaxPointsGRSpecificRule = (state: StateType, props: GetRoundIdFromPropsType) =>
  selectGRSpecificRuleFromRound(state, props)?.requiredPoints ?? 0;

export const selectMinStakeMultiplicatorGRSpecificRule = (state: StateType, props: GetRoundIdFromPropsType) =>
  selectGRSpecificRuleFromRound(state, props)?.minStakeMultiplier;

export const selectMaxStakeMultiplicatorGRSpecificRule = (state: StateType, props: GetRoundIdFromPropsType) =>
  selectGRSpecificRuleFromRound(state, props)?.maxStakeMultiplier;
